<template>

  <b-row>
    <b-col md="12">
      <b-card 
        no-body 
        :class="{ open: visibleBody }" 
      >
        <b-card-header 
          style="background-color: #0080C9; color: white; font:45px; padding:15px;  "
          :class="{ collapsed: !visibleBody }" 
          data-toggle="collapse"
          @click="() => visibleBody = !visibleBody" 
        >
          <span class="lead collapse-title"><strong>EXÁMENES DE LABORATORIO</strong></span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>
        <b-collapse 
          v-model="visibleBody" 
          role="tabpanel"
        >
          <b-card-body class="p-0">
            
            <AtencionLabAs400 v-if="tipoCobertura === '1'"/>

            <!-- <AtencionLabAux v-if="tipoCobertura && tipoCobertura !== '1'"/> -->

            <RegistroEnvioLabsAux
              v-if="tipoCobertura && tipoCobertura !== '1'"
              :tokenAtencion="tokenAtencion"
              :saveInState="saveLabsInState"
            />

          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>
  
</template>
  
<script>
import { mapState } from "vuex";
import 'flatpickr/dist/flatpickr.css';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';

import { RegistroEnvioLabsAux } from '@/views/laboratorio/components';
import AtencionLabAs400 from "./AtencionLabAs400.vue";



export default {
  
  name: 'AtencionLaboratorios',
  
  props: {

    idPaciente: {
      type: String,
      default: ''
    }
  },

  components: {
    AtencionLabAs400,
    RegistroEnvioLabsAux
  },
  

  created(){
    this.getTokenAtencion();
  },

  
  data() {
    return {
      visibleBody: false,
      tokenAtencion: null
    };
  },



  methods:{


    getTokenAtencion() {
      this.tokenAtencion = this.$route.params.token;
    },

    saveLabsInState(labsList) {
      this.$store.commit('setLaboratoriosAux',  labsList);
    }
  },
  
    
  computed: {

    ...mapState({
      stDataCita          : state => state.atencionCita.dataCita,

      stLaboratorioList   : state => state.atencionCita.laboratorios.laboratorioList,
      stLaboratoriosFinal : state => state.atencionMedica.editarAtencion.laboratorios.final,
    }),


    tipoCobertura(){
      if(!this.stDataCita) return null;
      return this.stDataCita.cobSeleccionada.id;
    }

  },
  
}
</script>
  